var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lv-table-column-controller"},[_c('lv-column-group',{ref:"group",attrs:{"is-ctrl-group":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }